import axios from 'axios'
import ssoPort from './ipPort/ssoPort'
import router from '@/router'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'


// 创建一个axios实例
const service = axios.create({
  baseURL: ssoPort,
  timeout: 60000
})

// 添加请求拦截器
service.interceptors.request.use(config => {
  return config;
}, error => {
  // 请求错误时做些事
  return Promise.reject(error);
});

// 添加响应拦截器
service.interceptors.response.use(response => {
    // console.log(response)
    const res = response.data;
    // 如果返回的状态不是200 就主动报错
    if(response.status != 200){
      return Promise.reject(res.errmsg || 'error')
    }else{
      if(res.code==401||res.code==403){
        localStorage.removeItem('hasLogin');
		    localStorage.removeItem('userData2C');
        localStorage.setItem("whcihSystemStyle","crm");
        sessionStorage.setItem("clearStoreUserData",'1');
        router.push({path:"/login"});
      }
    }
    return response;
    
}, error => {
    // console.log(error)
    return Promise.reject(error.response.data); // 返回接口返回的错误信息
})

export default service